"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireWildcard(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _modalLoaderUtils = require("@wsb/modal-loader-utils");
var _getComponent = _interopRequireDefault(require("../helpers/getComponent"));
var _getAppState = _interopRequireDefault(require("../helpers/getAppState"));
var _loadAppState = _interopRequireDefault(require("../helpers/loadAppState"));
var _noDOM = _interopRequireDefault(require("../helpers/noDOM"));
var _createPerfTracker = _interopRequireDefault(require("../helpers/createPerfTracker"));
var _getHivemindClient = _interopRequireWildcard(require("../helpers/getHivemindClient"));
var _analyticsTracker = _interopRequireDefault(require("../helpers/analyticsTracker"));
var _ErrorBoundary = _interopRequireDefault(require("./ErrorBoundary"));
var _createApmClient = _interopRequireDefault(require("../helpers/createApmClient"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } } /* eslint-disable complexity */ /* eslint-disable max-statements */
var RenderMode = _modalLoaderUtils.CONSTANTS.RenderMode,
  enUS = _modalLoaderUtils.CONSTANTS.enUS;
var isModalRender = _modalLoaderUtils.HELPERS.isModalRender,
  isOpen = _modalLoaderUtils.HELPERS.isOpen,
  once = _modalLoaderUtils.HELPERS.once;
var Manager = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Manager, _Component);
  var _super = _createSuper(Manager);
  function Manager(props) {
    var _this;
    (0, _classCallCheck2.default)(this, Manager);
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this, props].concat(args));
    _this.state = {
      appState: {},
      hasError: false,
      isVisible: false,
      hivemind: {
        ready: false,
        enabled: true
      }
    };
    _this.isComponentUnmounted = false;
    var namespace = props.namespace,
      rootDomain = props.rootDomain;
    // TODO replace perfTracker with apmClient?
    _this.perfTracker = (0, _createPerfTracker.default)(namespace);
    _this.apmClient = (0, _createApmClient.default)(namespace, rootDomain);
    _this.markLaunchStart = once(_this.perfTracker.markLaunchStart);
    _this.markLaunchEnd = once(_this.perfTracker.markLaunchEnd);
    return _this;
  }
  (0, _createClass2.default)(Manager, [{
    key: "initializeHivemind",
    value: function initializeHivemind(appConfig) {
      var _this2 = this;
      var hivemind = this.state.hivemind;
      if (!(appConfig !== null && appConfig !== void 0 && appConfig.enableHivemind)) {
        return this.setState({
          hivemind: _objectSpread(_objectSpread({}, hivemind), {}, {
            enabled: false
          })
        });
      }

      // appConfig.mockHivemind is only present within unit tests
      (0, _getHivemindClient.default)(this.props.rootDomain, !!appConfig.mockHivemind).ready.then(function () {
        _this2.setState({
          hivemind: _objectSpread(_objectSpread({}, hivemind), {}, {
            ready: true
          })
        });
      });
    }
  }, {
    key: "logError",
    value: function logError(error, info) {
      var urlParams = new URLSearchParams(window.location.search);
      var debugParam = urlParams.get('mlEnableConsoleDebug');
      var debugEnabled = (debugParam === null || debugParam === void 0 ? void 0 : debugParam.toLowerCase()) === 'true';
      if (debugEnabled) {
        // eslint-disable-next-line no-console
        console.error('ML_ERROR:', this.props.namespace, error, info);
      }

      // WARN Adding this label here means that all subsequent errors will be marked as fatal.  Since
      // this is a fatal error, it should be the last one reported.  However, that is not guaranteed.
      // I tried removing the label immediately after but then this error was not marked with it.
      this.apmClient.addLabels({
        fatalError: true
      });
      this.apmClient.captureError(error);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;
      this.isComponentUnmounted = false;
      var onWindowError = this.props.onWindowError;
      if (onWindowError) {
        window.addEventListener('error', onWindowError);
      }
      var nextState = {
        isVisible: true
      };
      var appState = (0, _getAppState.default)(this.props);
      if (appState.scriptLoaded) {
        this.initializeHivemind(appState.appConfig);
        return this.setState(_objectSpread(_objectSpread({}, nextState), {}, {
          appState: appState
        }));
      }
      this.perfTracker.markBundleRequestStart();
      (0, _loadAppState.default)(this.props).then(function (loadedState) {
        _this3.perfTracker.markBundleRequestEnd();
        if (_this3.isComponentUnmounted) return;
        _this3.initializeHivemind(loadedState.appConfig);
        _this3.setState(_objectSpread(_objectSpread({}, nextState), {}, {
          appState: loadedState
        }));
      }).catch(function (error) {
        if (_this3.isComponentUnmounted) return;
        onWindowError && onWindowError(new ErrorEvent('error', {
          error: error
        }));
        _this3.logError(error);
        _this3.setState(_objectSpread(_objectSpread({}, nextState), {}, {
          hasError: true
        }));
      });
      this.setState(nextState);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.onWindowError) {
        window.removeEventListener('error', this.props.onWindowError);
      }
      this.isComponentUnmounted = true;
    }
  }, {
    key: "getAllAppProps",
    value: function getAllAppProps(appProps) {
      var rootDomain = this.props.rootDomain;
      var _this$state = this.state,
        appConfig = _this$state.appState.appConfig,
        hivemind = _this$state.hivemind;
      var allProps = {
        appConfig: appConfig,
        appProps: appProps,
        rootDomain: rootDomain,
        open: isOpen(appProps),
        tracker: (0, _analyticsTracker.default)(rootDomain),
        apmClient: this.apmClient
      };
      if (hivemind.enabled && hivemind.ready) {
        allProps.hivemindClient = _getHivemindClient.client;
      }
      return allProps;
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      // HACK You are normally not supposed to perform side effects in render functions. We do it
      // here because it is the only way to guarantee that this is run before the child components
      // are evaluated.  The react lifecycle methods are all run after the children are evaluated.
      if (isOpen(this.props.appProps)) {
        this.markLaunchStart(); // only the first call is recorded
      }
      var _this$state2 = this.state,
        _this$state2$appState = _this$state2.appState,
        i18nContent = _this$state2$appState.i18nContent,
        scriptLoaded = _this$state2$appState.scriptLoaded,
        hasError = _this$state2.hasError,
        isVisible = _this$state2.isVisible,
        _this$state2$hivemind = _this$state2.hivemind,
        enabled = _this$state2$hivemind.enabled,
        ready = _this$state2$hivemind.ready;
      if (_noDOM.default || !isVisible) return null;
      var _this$props = this.props,
        appProps = _this$props.appProps,
        Error = _this$props.errorComponent,
        onReactError = _this$props.onReactError,
        renderMode = _this$props.renderMode;
      var ErrorI18n = function ErrorI18n() {
        return /*#__PURE__*/_react.default.createElement(Error, {
          i18nContent: i18nContent
        });
      };
      if (hasError) return isOpen(appProps) ? /*#__PURE__*/_react.default.createElement(ErrorI18n, null) : null;
      var isModal = isModalRender(renderMode);
      var App = (0, _getComponent.default)(this.props);
      var onVisualComplete = function onVisualComplete() {
        return _this4.markLaunchEnd();
      };
      var perfTracker = {
        startEvent: this.perfTracker.startEvent,
        endEvent: this.perfTracker.endEvent
      };
      var root = null;
      if (scriptLoaded && i18nContent && App && (!enabled || ready)) {
        var allAppProps = _objectSpread(_objectSpread({}, this.getAllAppProps(appProps)), {}, {
          i18nContent: i18nContent,
          onVisualComplete: onVisualComplete,
          perfTracker: perfTracker,
          renderMode: renderMode
        });
        root = /*#__PURE__*/_react.default.createElement(App, allAppProps);
      } else {
        var _this$props$loaderCom = this.props.loaderComponent,
          Loader = _this$props$loaderCom === void 0 ? _react.default.Fragment : _this$props$loaderCom;
        root = isModal && isOpen(appProps) ? /*#__PURE__*/_react.default.createElement(Loader, null) : null;
      }
      if (!root) return root;
      var onError = function onError(error, info) {
        _this4.logError(error, info);
        onReactError(error, info);
      };
      var wrappedRoot = /*#__PURE__*/_react.default.createElement(_ErrorBoundary.default, {
        errorComponent: ErrorI18n,
        onError: onError,
        namespace: this.props.namespace,
        isModalOpen: isOpen(appProps)
      }, root);
      var container = this.props.appProps.container ? this.props.appProps.container : document.body;
      return isModal ? /*#__PURE__*/_reactDom.default.createPortal(wrappedRoot, container) : wrappedRoot;
    }
  }]);
  return Manager;
}(_react.Component);
Manager.propTypes = {
  appConfigKey: _propTypes.default.string.isRequired,
  appProps: _propTypes.default.shape({
    open: _propTypes.default.bool,
    container: _propTypes.default.node,
    proxyBaseUrl: _propTypes.default.string,
    sourceApp: _propTypes.default.string
  }).isRequired,
  cdnBaseUrl: _propTypes.default.string,
  cdnLocalBaseUrl: _propTypes.default.string,
  cdnVirtualPath: _propTypes.default.string.isRequired,
  deps: _propTypes.default.object.isRequired,
  errorComponent: _propTypes.default.elementType.isRequired,
  hasBundledCss: _propTypes.default.bool,
  i18nPath: _propTypes.default.string,
  i18nVersionKey: _propTypes.default.string,
  loaderComponent: _propTypes.default.elementType,
  market: _propTypes.default.string,
  namespace: _propTypes.default.string.isRequired,
  onReactError: _propTypes.default.func,
  onWindowError: _propTypes.default.func,
  renderMode: _propTypes.default.oneOf([RenderMode.MODAL, RenderMode.EMBED]),
  rootDomain: _propTypes.default.string,
  versionEnvKey: _propTypes.default.string,
  versionKey: _propTypes.default.string.isRequired,
  versionParam: _propTypes.default.string
};
Manager.defaultProps = {
  hasBundledCss: true,
  i18nPath: 'i18n',
  i18nVersionKey: '',
  market: enUS,
  onReactError: function onReactError() {},
  renderMode: RenderMode.MODAL,
  rootDomain: 'dev-godaddy.com',
  versionEnvKey: '',
  versionParam: ''
};
var _default = exports.default = Manager;